var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SparkOutput_1;
import { JsonSchemaV2, JSON } from '@symon-ai/wisepipe-serialize';
import { sparkOutputSchemaValidation } from '../validations.generated';
export const sparkOutputSchema = {
    $id: 'urn:wisepipe-compute-activity-domain:SparkOutput',
    type: 'object',
    properties: {
        status: { type: 'string', pattern: 'ok|error' },
        // error fields
        ename: { type: 'string' },
        evalue: { type: 'string' },
        traceback: { type: 'array', items: { type: 'string' } }
    },
    required: ['status']
};
let SparkOutput = SparkOutput_1 = class SparkOutput {
    constructor(status, ename, evalue, traceback) {
        this.status = status;
        if (ename) {
            this.ename = ename;
        }
        if (evalue) {
            this.evalue = evalue;
        }
        if (traceback) {
            this.traceback = traceback;
        }
        JSON.validate(this, SparkOutput_1);
    }
    getErrorCause() {
        let info = [`${this.ename}: ${this.evalue}`];
        if (this.traceback) {
            info = info.concat(this.traceback);
        }
        return info.join('\n');
    }
};
SparkOutput = SparkOutput_1 = __decorate([
    JsonSchemaV2(sparkOutputSchema, sparkOutputSchemaValidation)
], SparkOutput);
export { SparkOutput };
//# sourceMappingURL=sparkOutput.js.map